import request from '../../axios';

export const getTakenLoanDetails = async (loanRequestGuid?: string) => {
  const {data}: {data: IGetTakenLoanDetailsResponse} = await request.get(
    `api/v2/payment/list-installment/taken-loan/` + loanRequestGuid,
  );

  return data;
};
